/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Alexander Golshtein
 * @version 1.25.1
 * @since 1.25.1
 */

import styled, { css } from 'styled-components';

import { colors } from '@/main/theme';

interface ICarouselDotStyledProps {
    active: boolean;
}

interface IButtonGroupArrowProps {
    side: 'left' | 'right';
}

export const NewsImagesWrapper = styled.div`
    width: 640px;
    height: 320px;
    position: relative;
    margin-bottom: 60px;

    & .react-multi-carousel-dot-list {
        margin-bottom: -28px;
    }

    .react-multi-carousel-list {
        width: 100%;
        height: 100%;
        border-radius: 12px;
    }
`;

export const NewsImagesItem = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const CarouselDotStyled = styled.li<ICarouselDotStyledProps>`
    width: ${(props) => (props.active ? '20px' : '8px')};
    height: 8px;
    background-color: ${(props) =>
        props.active ? colors.corporateHeaderCounterBg : colors.backgroundColorDisabledDark};
    border-radius: ${(props) => (props.active ? '4px' : '50%')};
    margin-left: 12px;
    cursor: pointer;
    transition: width linear 0.4s;

    &:first-child {
        margin-left: 0;
    }
`;

export const NewsImagesButtonGroupWrapper = styled.div`
    position: absolute;
    width: 100%;
    top: 50%;
`;

export const ButtonGroupArrow = styled.img<IButtonGroupArrowProps>`
    cursor: pointer;
    position: absolute;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 50%;

    ${(props) =>
        props.side === 'left'
            ? css`
                  left: 0;
                  transform: translate(-50%, -50%);
              `
            : css`
                  right: 0;
                  transform: translate(50%, -50%);
              `}
`;
